const CONTEXT_KEYS = [
  "siteId",
  "plantId",
  "assetId",
  "tierId",
  "componentId",
  "instrumentId",
];

const getMatch = (pathname, pattern) => pathname.match(pattern)?.[1] || "";

export const getLogisticsContextFromPathname = (pathname = "") => ({
  siteId: getMatch(pathname, /\/sites\/([^/]+)/),
  plantId: getMatch(pathname, /\/plants\/([^/]+)/),
  assetId: getMatch(pathname, /\/assets\/([^/]+)/),
  tierId: getMatch(pathname, /\/sub-asset\/([^/]+)/),
  componentId: getMatch(pathname, /\/components\/([^/]+)/),
  instrumentId: getMatch(pathname, /\/instruments\/([^/]+)/),
});

export const parseLogisticsNavigationContext = (search = "") => {
  const params = new URLSearchParams(search);

  return CONTEXT_KEYS.reduce((context, key) => {
    context[key] = params.get(key) || "";
    return context;
  }, {});
};

export const buildLogisticsNavigationSearch = (context = {}) => {
  const params = new URLSearchParams();

  CONTEXT_KEYS.forEach((key) => {
    if (context[key]) params.set(key, String(context[key]));
  });

  const search = params.toString();
  return search ? `?${search}` : "";
};

export const buildContextualLogisticsPath = (pathname = "") => {
  if (pathname === "/logistics") return "/logistics";

  return `/logistics${buildLogisticsNavigationSearch(
    getLogisticsContextFromPathname(pathname),
  )}`;
};

export const hasLogisticsNavigationContext = (context = {}) =>
  Boolean(
    context.siteId ||
      context.plantId ||
      context.assetId ||
      context.tierId ||
      context.componentId,
  );

// Prefers the /logistics URL's query-string context; falls back to the
// shared BreadcrumbContext (the same "where am I" state the Design &
// Engineering pages already rely on) when the URL carries none — e.g.
// landing on /logistics directly rather than via a site/plant/asset-scoped
// link.
export const resolveLogisticsNavigationContext = (urlContext, breadcrumbs = {}) => {
  if (hasLogisticsNavigationContext(urlContext)) {
    return { context: urlContext, isFromUrl: true };
  }

  return {
    context: {
      siteId: breadcrumbs.site?.id ? String(breadcrumbs.site.id) : "",
      plantId: breadcrumbs.plant?.id ? String(breadcrumbs.plant.id) : "",
      assetId: breadcrumbs.asset?.id ? String(breadcrumbs.asset.id) : "",
      tierId: breadcrumbs.subAsset?.id ? String(breadcrumbs.subAsset.id) : "",
      componentId: breadcrumbs.component?.id
        ? String(breadcrumbs.component.id)
        : "",
      instrumentId: breadcrumbs.instrument?.id
        ? String(breadcrumbs.instrument.id)
        : "",
    },
    isFromUrl: false,
  };
};

export const getLogisticsContextForItem = (item = {}) => ({
  siteId: item.siteId || "",
  plantId: item.plantId || "",
  assetId:
    item.objectType === "equipment"
      ? item.id
      : item.equipmentId || "",
  tierId:
    item.objectType === "tier"
      ? item.id
      : item.tierId || "",
  componentId:
    item.objectType === "panelcomponent"
      ? item.id
      : item.componentId || "",
  instrumentId: item.objectType === "instrument" ? item.id : "",
});
